import { useTranslation } from "react-i18next";

import type { RhythmKind } from "./progressMath";

/** Strength | Cardio | All, in words: the Rhythm card's chips and the
 *  Workouts list's (#321). */
export function useRhythmKindLabels(): Record<RhythmKind, string> {
  const { t } = useTranslation();
  return {
    strength: t("mobile.progress.rhythmKind.strength", { defaultValue: "Strength" }),
    cardio: t("mobile.progress.rhythmKind.cardio", { defaultValue: "Cardio" }),
    all: t("mobile.progress.rhythmKind.all", { defaultValue: "All" }),
  };
}
